import * as models from './orderModels';
// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface SetOrders { type: 'SET_ORDERS'; data: models.ApiOrderObject[]; }
interface SetSingleOrder { type: 'SET_SINGLE_ORDER'; data: models.ApiOrderObject; }
interface SetLoading { type: 'SET_LOADING_ORDERS'; data: boolean; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction =    
        SetOrders
    |   SetSingleOrder
    |   SetLoading
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const orderActionCreators = {
    setOrders: (data: models.ApiOrderObject[]) => <SetOrders> { type: 'SET_ORDERS', data: data },
    setSingleOrder: (data: models.ApiOrderObject) => <SetSingleOrder> { type: 'SET_SINGLE_ORDER', data: data },
    setLoading: (data: boolean) => <SetLoading> { type: 'SET_LOADING_ORDERS', data: data } 
};


// WEBPACK FOOTER //
// ./src/data/order/orderActions.ts